import api from "@/lib/api";

// LIASROOTS campaign option lists (shared vocab with the backend) + helpers.
export const SERVICES = [
  { key: "soft", label: "Soft landscaping / planting" },
  { key: "turf", label: "Turf & lawn care" },
  { key: "arbor", label: "Arboriculture / tree care" },
  { key: "irrigation", label: "Irrigation systems" },
  { key: "hardscape", label: "Hardscaping / structures" },
  { key: "maintenance", label: "Grounds maintenance" },
  { key: "design_build", label: "Landscape design & build" },
  { key: "vertical", label: "Skyrise / vertical greenery" },
];

export const PRIORITIES = [
  { key: "win_tenders", label: "Winning more tenders / contracts" },
  { key: "prove_value", label: "Proving our value to clients" },
  { key: "efficiency", label: "Improving operational efficiency" },
  { key: "sustainability", label: "Sustainability & environmental credentials" },
  { key: "compliance", label: "Meeting standards & compliance" },
  { key: "digital", label: "Better digital records" },
  { key: "not_sure", label: "Not sure yet" },
];

export const CHANNELS = [
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "whatsapp", label: "WhatsApp" },
];

export const MEMBERSHIP = [
  { key: "yes", label: "Yes" },
  { key: "no", label: "No" },
  { key: "not_sure", label: "Not sure" },
];

export const SG_OPS = [
  { key: "yes", label: "Yes" },
  { key: "planning", label: "Planning to" },
  { key: "no", label: "No" },
];

// Optional profiling
export const ROLES = ["Owner / Director", "Operations manager", "Supervisor / Foreman", "Admin / Office", "Other"];
export const SIZES = ["1–10", "11–50", "51–200", "200+"];
export const SITE_TYPES = [
  "Town councils / HDB estates", "Condominiums / MCST", "Commercial / offices",
  "Parks & public spaces", "Streetscape / roadside", "Institutional (schools/hospitals)", "Private residential",
];
export const PILOT_SITE = [
  { key: "yes", label: "Yes, we have one in mind" },
  { key: "maybe", label: "Maybe / to discuss" },
  { key: "no", label: "Not yet" },
];
export const TIMEFRAMES = ["Within 1 month", "1–3 months", "3–6 months", "6+ months", "Not sure"];
export const RECORDS = [
  "Work logs / job sheets", "Photos", "Plant / asset lists", "Water / resource usage",
  "Safety records", "Client reports", "Few / none yet",
];
export const ISO_POS = ["Certified", "In progress", "Planning to", "Not pursuing", "Not sure"];

export const STATUS_LABELS = {
  received: "Received", eligibility_review: "Eligibility review", discovery: "Discovery",
  scope_proposed: "Scope proposed", confirmed: "Confirmed", waitlisted: "Waitlisted",
  not_proceeding: "Not proceeding",
};
export const STATUS_STYLE = {
  received: "bg-slate-100 text-slate-700 border-slate-200",
  eligibility_review: "bg-sky-100 text-sky-800 border-sky-200",
  discovery: "bg-indigo-100 text-indigo-800 border-indigo-200",
  scope_proposed: "bg-amber-100 text-amber-900 border-amber-300",
  confirmed: "bg-[#B7E64B] text-[#09292D] border-[#9ccc2f]",
  waitlisted: "bg-purple-100 text-purple-800 border-purple-200",
  not_proceeding: "bg-rose-100 text-rose-800 border-rose-200",
};

export const labelOf = (list, key) => (list.find((x) => x.key === key) || {}).label || key;

export const fmtSgt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-SG", {
      timeZone: "Asia/Singapore", day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    }) + " SGT";
  } catch { return iso; }
};

// Anonymous funnel analytics (no PII) — fire-and-forget with a per-browser session id.
const _SKEY = "liasroots_sid";
function _sid() {
  let s = localStorage.getItem(_SKEY);
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(_SKEY, s); }
  return s;
}
export function track(event) {
  api.post("/campaign/event", { event, session: _sid() }).catch(() => { /* best effort */ });
}
